'use strict'

class Article {
    
    constructor() {
        this.BASE_URL = App.baseUrl;
    }
    
    init () {
        if($('#mainGalleryDesktop').length > 0){
            tns({
                container: '#mainGalleryDesktop',
                slideBy: 1,
                controls: true,
                controlsText: ["", ""],
                nav: true,
                navPosition: 'bottom',
                speed: 1000,
                mouseDrag: true,
                preventScrollOnTouch: 'auto',
                preventActionWhenRunning: true
            });
        }
        
        if($('#mainGalleryMobile').length > 0){
            tns({
                container: '#mainGalleryMobile',
                slideBy: 1,
                controls: false,
                nav: true,
                navPosition: 'bottom',
                speed: 1000,
                mouseDrag: true,
                preventScrollOnTouch: 'auto',
                preventActionWhenRunning: true
            });
        }
    }
}

export default Article;